import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './Export.css';
import Layout from '../Layout/Layout';

const sampleData = [
  { author: 'John Doe', articles: 15, payoutRate: 10 },
  { author: 'Jane Smith', articles: 20, payoutRate: 12 },
  { author: 'Alex Brown', articles: 10, payoutRate: 8 },
];

const ExportPage = () => {
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Payout Report", 20, 10);
    doc.autoTable({
      head: [['Author', 'Articles', 'Payout Rate', 'Total Payout']],
      body: sampleData.map(row => [
        row.author,
        row.articles,
        row.payoutRate,
        row.articles * row.payoutRate,
      ]),
    });
    doc.save('payout_report.pdf');
  };

  const exportCSV = () => {
    const ws = XLSX.utils.json_to_sheet(sampleData.map(row => ({
      Author: row.author,
      Articles: row.articles,
      'Payout Rate': row.payoutRate,
      'Total Payout': row.articles * row.payoutRate
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Payout Report');
    const wbout = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, 'payout_report.xlsx');
  };

  return (
    <Layout>
        <div className="export-wrapper">
        <h2 className="export-title">📊 Export Financial Reports</h2>
        <p className="export-description">
            Download your payout reports as PDF or Excel files. Useful for record keeping and sharing.
        </p>
        <div className="export-buttons">
            <button className="pdf-btn" onClick={exportPDF}>
            📄 Export as PDF
            </button>
            <button className="excel-btn" onClick={exportCSV}>
            📊 Export as Excel
            </button>
        </div>
        </div>
    </Layout>
    
  );
};

export default ExportPage;
